import { Component, OnInit, OnDestroy } from '@angular/core';
import { ModalService } from 'src/app/services/modal.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { SharedService } from 'src/app/services/shared.service';
import { UtilsService } from 'src/app/services/utils.service';
import { environment } from 'src/environments/environment';
import { ContraseniamodalComponent } from '../../modals/contraseniamodal/contraseniamodal.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styles: [
  ]
})
export class HeaderComponent implements OnInit, OnDestroy {
  descripcionSistema: String = environment.ENVIRONMENT.DESCRIPCION_SISTEMA;
  usuario: any = {};
  subscription: any;

  constructor(private sharedService: SharedService, private modalService: ModalService, private utilsService: UtilsService, private alertsService: NotificacionesService) {
    this.subscription = this.sharedService.getUserData().subscribe(data => {
      this.usuario = data;
      //console.log('this.usuario', this.usuario);
    });
  }

  ngOnInit(): void {
    if (this.utilsService.validarObjeto(this.usuario.contrasenaEfimera) && this.usuario.contrasenaEfimera === 1) {
      this.alertsService.info('Para poder continuar deberá cambiar la contraseña temporal.', false, 'Cambiar Contraseña');
      this.cambiarContrasenia();
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  cambiarContrasenia(): void {
    this.modalService.mostrarModal(ContraseniamodalComponent, 'md', this.utilsService.clonarObjeto(this.usuario));
  }

  cerrarSesion(): void {
    this.utilsService.redirectLogin();
  }

}
